import React from 'react';
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import background from "../img/new-auth-background.png";
import {Colors} from "../theme/colors";
import {useTranslation} from "react-i18next";
import {StyledButton} from "./ui-base/button";
import {StyledH1, StyledP1, StyledP2} from "./ui-base/styles";
import {Link} from "react-router-dom";
import {Hidden} from "@material-ui/core";
import {CustomNielsenLogo} from "./ui-base/new-icons/custom-nielsen-logo";

const LoginWrapper: React.FC<LoginWrapperProps> = ({children, pageType}) => {
    const { t } = useTranslation('common');

    return (
        <StyledLoginContainer
            container
            direction={'row'}
        >
            <Grid item container direction={"row"} justifyContent="center" alignItems={"center"} xs={12} sm={12} lg={5}>
                <StyledCardWrapper item container direction={"column"} xs={12}>
                    {children}
                </StyledCardWrapper>
            </Grid>

            <Hidden mdDown>
                <StyledCardWrapperInfo item container direction={"column"} xs={12} sm={12} lg={7}>
                    <StyledCardWrapperInfoContent item container direction={"column"} justifyContent="space-between">
                        <StyledInfoHeader item container direction="row" justifyContent="flex-end" alignItems="center">
                            <StyledPInfo>
                                {t(pageType !== 'login' ? 'loginWrapper.haveAccount' : 'loginWrapper.notAccount')}
                            </StyledPInfo>
                            <Link to={pageType !== 'login' ? '/login' : '/register'}>
                                <StyledButton style={{marginLeft: '1rem'}} type={"button"} color={"primary"}>
                                    {t(pageType !== 'login' ? 'register.logIn' : 'login.register')}
                                </StyledButton>
                            </Link>
                        </StyledInfoHeader>
                        <StyledInfoContainer item>
                            <StyledH2Info>{t('loginWrapper.t1a')} <span>{t('loginWrapper.t1b')}</span> {t('loginWrapper.t1c')}</StyledH2Info>
                            <StyledPInfo>{t('loginWrapper.t2')}</StyledPInfo>
                        </StyledInfoContainer>
                        <StyledNielsenContainer item>
                            <div>
                                <StyledNielsenTitle>{t('loginWrapper.cooperateWith')}</StyledNielsenTitle>
                            </div>
                            <div>
                                <StyledNielsenLogo/>
                            </div>
                        </StyledNielsenContainer>
                    </StyledCardWrapperInfoContent>
                </StyledCardWrapperInfo>
            </Hidden>
        </StyledLoginContainer>
    );
}

const StyledLoginContainer = styled(Grid)`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: ${Colors.whiteBackground};
`;

const StyledCardWrapperInfo = styled(Grid)`
  position: relative;
  padding: 2rem;
`;

const StyledCardWrapperInfoContent = styled(Grid)`
  position:relative;
  flex: 1;
  border-radius: 44px;
  border: 1px solid ${Colors.grayBorder};
  background: linear-gradient(0deg, rgba(52, 15, 87, 0.50) 0%, rgba(52, 15, 87, 0.50) 100%), url(${background}), lightgray -91.358px -133.195px / 121.435% 132.802% no-repeat;
  background-position: center;
`;

const StyledH2Info = styled(StyledH1)`
  color: ${Colors.whiteText};
  margin-bottom: 1.5rem;
  
  span {
    color: ${Colors.yellowText};
  }
`;

const StyledPInfo = styled(StyledP1)`
  color: ${Colors.whiteText};
  max-width: 600px;
`;

const StyledInfoHeader = styled(Grid)`
  padding: 2rem 2.1rem 0 0;
`;

const StyledInfoContainer = styled(Grid)`
  max-width: 800px;
  margin: 0 auto 3rem;
  padding: 1rem;
`;

const StyledNielsenContainer = styled(Grid)`
  position: absolute;
  bottom: 2rem;
  right: 2rem;
`;

const StyledCardWrapper = styled(Grid)`
  width: 100%;
  max-width: 400px;
`;

const StyledNielsenTitle = styled(StyledP2)`
  text-transform: uppercase;
  color: ${Colors.secondary70};
  font-weight: 400;
`;

const StyledNielsenLogo = styled(CustomNielsenLogo)`
  width: 140px;
`;

export default LoginWrapper;

export interface LoginWrapperProps {
    pageType: 'login' | 'register' | 'other';
}
